<template>
    <div class="unpublic">
        <img
            src="../assets/unpublic.jpg"
            alt=""
        >
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" scoped>
.unpublic {
  display: flex;

  img {
    width: 100vw;
  }
}
</style>
